import {Component, EventEmitter, OnChanges, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Subscription} from 'rxjs';
import {Offset} from '../../models/Offset';
import {GenericArray} from '../../models/GenericArray';
import {DialogDetailComponent} from '../general-components/dialog-detail/dialog-detail.component';
import {ServiceChangesModel} from '../../models/ServiceChangesModel';
import {ServiceChangesService} from './service/service-changes.service';
import * as toastr from 'toastr';
import {BaseGeneralComponent} from '../BaseGeneralComponent';
import {LoaderService} from '../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../general-services/service-num-anno-mese/num-anno-mese.service';
import {Router} from '@angular/router';
import {ContractTypeService} from '../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../users/service/users.service';

@Component({
  selector: 'app-service-changes',
  templateUrl: './service-changes.component.html',
  styleUrls: ['./service-changes.component.scss']
})
export class ServiceChangesComponent extends BaseGeneralComponent implements OnInit, OnChanges, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: ServiceChangesModel[];
  isServiceSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getAllSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: ServiceChangesModel;
  numAnnoMeseData: any;
  contractTypeData: any;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  constructor(private serviceChangesService: ServiceChangesService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private router: Router) {
    super();
    this.sectionId = this.SECTIONS.SERVICE_CHANGES;
    this.loaderService.display(true);
    this.user = JSON.parse(sessionStorage.getItem('user'));
    const getFromSession = this.checkRole();
    this.showNewEditDelete = !getFromSession;
  }

  ngOnInit() {
    this.isServiceSection = this.returnIsContractSection(this.router.url);
    this.selectedRowIndex = -1;

    this.displayedColumns = ['RegionDesc', 'ContractType' , 'LocalCustomerDesc',
                            'ResourceUnitCod', 'ResourceUnitName', 'DesignServicesDesc',
                            'UnitsDesc', 'ShareName', 'delta', 'actions'];

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.SERVICE_CHANGES_OFFSET);
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.getSessionStorageFilter();
    this.init();
  }

  ngOnChanges() {
  }

  init() {
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        const providerDefault = this.filter.provider;
        this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);

        if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
          const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
          this.filter.numAnnoMese = numAnnoMese;
        }

        this.getDataPage(this.offset, this.filter);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
    });
  }

  getDataPage(offset: Offset, filter: ServiceChangesModel) {
    this.getAllSubscribe = this.serviceChangesService.getPage(offset, filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const serviceChangesData = this.dataSource.find(data => data.id === id) as ServiceChangesModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(serviceChangesData.numAnnoMese)},
      {id: 'Provider Cod', value: this.toCustomString( serviceChangesData.provider.description)},
      {id: 'Provider Description', value: this.toCustomString( serviceChangesData.provider.description)},
      {id: 'Region Cod', value: this.toCustomString(serviceChangesData.region.description)},
      {id: 'Region Description', value: this.toCustomString(serviceChangesData.region.description)},
      {id: 'Contract Type Cod', value: this.toCustomString( serviceChangesData.contractType.description)},
      {id: 'Contract Type Description', value: this.toCustomString( serviceChangesData.contractType.description)},
      {id: 'Local Customer Cod', value: this.toCustomString( serviceChangesData.localCustomer.description)},
      {id: 'Local Customer Description', value: this.toCustomString( serviceChangesData.localCustomer.description)},
      {id: 'Resource Unit Cod', value: this.toCustomString( serviceChangesData.resourceUnit.cod)},
      {id: 'Resource Unit Name', value: this.toCustomString( serviceChangesData.resourceUnit.name)},
      {id: 'SL1 Cod', value: this.toCustomString(serviceChangesData.designServices.cod)},
      {id: 'SL1 Description', value: this.toCustomString(serviceChangesData.designServices.description)},
      {id: 'Sharename', value: this.toCustomString( serviceChangesData.shareName)},
      {id: 'Delta', value: this.toCustomString( serviceChangesData.delta)}
      ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.SERVICE_CHANGES_OFFSET);
    this.getDataPage(this.offset, this.filter);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.listData.sort = this.sort;

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.serviceChangesService.softDelete(id)
        .subscribe(
          (result: boolean) => {
            if (result) {
              toastr.success('Service change with id ' + id + ' was deleted with success', 'Success');
              this.getDataPage(this.offset, this.filter);
            } else {
              toastr.error('Service change  with id ' + id + ' was not deleted', 'Error');
            }
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered;
    this.getDataPage(this.offset, this.filter);

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getAllSubscribe) {
      this.getAllSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;

  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.SERVICE_CHANGES_FILTER));
    this.filter = filter_ ? filter_ : new ServiceChangesModel();
  }
}
